import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import {toList} from "../../helpers/helpers";
import {BulkOrderLineItemModel} from "../../bulk-ordering/bulk-order-line-item.model";

@Injectable()
export class BulkOrderDesignService {
  private url = "/api/bulk-order-design";

  constructor(private http: HttpClient) {}

  getDeviceList(bulkOrderId: string): Promise<BulkOrderLineItemModel[]> {
    const params = {bulkOrderId};

    return this.http.get<{rows: BulkOrderLineItemModel[]}>(`${this.url}/device-list`, {params})
      .pipe(map(json => toList(row => new BulkOrderLineItemModel(row), json.rows)))
      .toPromise();
  }

  saveDesign(bulkOrderId: string, design: {[key: string]: any}[]): Promise<boolean> {
    return this.http.post<{success: boolean}>(`${this.url}/device-list`, {bulkOrderId, design})
      .pipe(map(json => !!json.success))
      .toPromise();
  }
}
